import { DOCTYPES } from '@/constants/doctypes'
import { HAS_LIST_VIEW_ONE_PERMISSION_OF } from '@/constants/permissions'
import { createSingleViewRoutes } from '@/routers/routes/createDoctypeRoutes'

const { home: routeBuyingDashboardHome, root: routeBuyingDashboardRoot } = createSingleViewRoutes({
  // Dashboard aggregates every buying doctype below (some via raw SQL that bypasses
  // Frappe permissions), so require read on all of them before the view renders.
  doctypes: {
    [DOCTYPES.PURCHASE_ORDER]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
    [DOCTYPES.REQUEST_FOR_QUOTATION]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
    [DOCTYPES.SUPPLIER_QUOTATION]: HAS_LIST_VIEW_ONE_PERMISSION_OF,
  },
  ifOwner: false,
  name: 'buying-dashboard',
  path: 'dashboard',
  view: async () => await import('@/components/views/buying/BuyingDashboard.vue'),
})

export { routeBuyingDashboardHome, routeBuyingDashboardRoot }
